import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from 'src/app/core/services/config.service';
import { CarReceptionData } from '../models/CarReceptionData';
import { Observable } from 'rxjs';
import { SearchCarReceptionDatasCriteria } from '../models/SearchCarReceptionDatasCriteria';
import { CarReceptionDataSearchResultItem } from '../models/CarReceptionDataSearchResultItem';
import { StoreCarReceptionDataToClaimDocumentationRequest } from '../../documents/models/StoreCarReceptionDataToClaimDocumentationRequest';
import { CarReceptionDataForReturn } from '../models/CarReceptionDataForReturn';


@Injectable({
  providedIn: 'root'
})
export class CarReceptionDataService {

  constructor(private http: HttpClient,
    private configService: ConfigService) {
  }

  public getCarReceptionData(id:number): Observable<CarReceptionData> {
    return this.http.get<CarReceptionData>(
      this.configService.PortalWebApiUrl + 'CarReceptionData/' + id);
  }

  public getPrefilledCarReceptionData(claimIdentifier:string): Observable<CarReceptionData> {
    return this.http.get<CarReceptionData>(
      this.configService.PortalWebApiUrl + 'CarReceptionData/prefill/' + claimIdentifier);
  }

  public storeReceptionData(data: CarReceptionData) : Observable<CarReceptionData> {

    return this.http.post<CarReceptionData>(
      this.configService.PortalWebApiUrl + 'CarReceptionData/store', data);
  }

  public searchCarReceptionDatas(criteria: SearchCarReceptionDatasCriteria): Observable<CarReceptionDataSearchResultItem[]> {
    return this.http.post<CarReceptionDataSearchResultItem[]>(
      this.configService.PortalWebApiUrl + 'CarReceptionData/search', criteria);
  }

  public storeInClaimDocumentation(request: StoreCarReceptionDataToClaimDocumentationRequest): Observable<number> {

    return this.http.post<number>(
      this.configService.PortalWebApiUrl + 'CarReceptionData/storeInClaimDocumentation',  request);
  }

  public returnCarDocument(request: CarReceptionDataForReturn): Observable<string> {

    return this.http.post<string>(
      this.configService.PortalWebApiUrl + 'CarReceptionData/returnCarDocument',  request);
  }

}
